import type React from 'react';

export type RunColor = 'completed' | 'skipped' | 'failed' | null;

export const getRunOverrideStyle = (runColor: RunColor): React.CSSProperties => {
  if (!runColor) return {};
  switch (runColor) {
    case 'completed':
      return { border: '2px solid #27ae60', background: '#eafaf1' };
    case 'skipped':
      return { border: '2px solid #e67e22', background: '#fef9ec' };
    case 'failed':
      return { border: '2px solid #c0392b', background: '#fdf0ef' };
    default:
      return {};
  }
};
